/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Personalitybigfiveemotionalstabilityright5Inputs */



/**
* | output |
* | --- |
* | "Backbone" |
*
* @param {Personalitybigfiveemotionalstabilityright5Inputs} inputs
* @param {{ locale?: "ru" | "en" | "es" }} options
* @returns {LocalizedString}
*/
const personalitybigfiveemotionalstabilityright5 = /** @type {((inputs?: Personalitybigfiveemotionalstabilityright5Inputs, options?: { locale?: "ru" | "en" | "es" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Personalitybigfiveemotionalstabilityright5Inputs, { locale?: "ru" | "en" | "es" }, {}>} */ ((inputs = {}, options = {}) => {
	void inputs;
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return /** @type {LocalizedString} */ ("Backbone")
	if (locale === "es") return /** @type {LocalizedString} */ ("Firme")
	return /** @type {LocalizedString} */ ("Стержень")
});
export { personalitybigfiveemotionalstabilityright5 as "personalityBigFiveEmotionalStabilityRight" }